var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-wrap" }, [
    _c("img", {
      staticClass: "bg",
      attrs: { src: require("../../assets/imgs/loginBg.png"), alt: "" },
    }),
    _vm._v(" "),
    _c("div", { staticStyle: { display: "flex", margin: "10% auto" } }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "login" }, [
        _c("div", { staticClass: "boxTitle" }, [
          _vm._v("咖德保安运营管理系统"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub-title" }),
        _vm._v(" "),
        _vm.type == 1
          ? _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.ruleForm, rules: _vm.rules },
                  },
                  [
                    _c("el-form-item", { attrs: { label: "", prop: "name" } }, [
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入账号" },
                            model: {
                              value: _vm.ruleForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "name", $$v)
                              },
                              expression: "ruleForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "", prop: "pass" } }, [
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入密码",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.ruleForm.pass,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "pass", $$v)
                              },
                              expression: "ruleForm.pass",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "", prop: "code" } }, [
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入验证码" },
                            model: {
                              value: _vm.ruleForm.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "code", $$v)
                              },
                              expression: "ruleForm.code",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "sendCode" }, [
                            _c("img", {
                              staticStyle: {
                                width: "100px",
                                height: "40px",
                                "margin-left": "20px",
                              },
                              attrs: { src: _vm.codeObj.imageBase, alt: "" },
                              on: { click: _vm.getImg },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("ruleForm")
                            },
                          },
                        },
                        [_vm._v("登录")]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 2
          ? _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm1",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.ruleForm1, rules: _vm.rules1 },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "phone" } },
                      [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入手机号码" },
                              model: {
                                value: _vm.ruleForm1.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "phone", $$v)
                                },
                                expression: "ruleForm1.phone",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "", prop: "code" } }, [
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入验证码" },
                            model: {
                              value: _vm.ruleForm1.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "code", $$v)
                              },
                              expression: "ruleForm1.code",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "sendCode" }, [
                            _vm._v("发送验证码"),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          staticStyle: { "margin-bottom": "40px" },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("ruleForm1")
                            },
                          },
                        },
                        [_vm._v("\n              登录\n            ")]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 1
          ? _c("div", { staticClass: "box" }, [
              _c("div"),
              _vm._v(" "),
              _c("div", [_vm._v("忘记密码？")]),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loginImg" }, [
      _c("img", {
        attrs: { src: require("../../assets/imgs/loginImg.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }